export const BODY_THEME_RED_MARLBORO = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 720 504";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};


	return(
		<div>
		<svg xmlns="http://www.w3.org/2000/svg"
			width={svgWidth}
			height={svgHeight}
			viewBox={svgViewBox}
			preserveAspectRatio={svgPreserveAspectRatio}
			style={svgStyle}
		>

        
      
{/*Base*/}

    {/*Two*/}
    <polygon 
        fill="rgb(210,210,210)" 
        points="60.552,329.4 92.127,396 655.779,396 655.779,275.4 642.933,250.745 608.1,230.634 436.5,209.563 86.8,185.109 76.176,203.256 76.193,275.4 60.568,275.4 60.552,329.4"
    />
    {/*One*/}
    <path 
        fill="rgb(230,230,230)" 
        d="M86.8,185.109l349.7,24.454l171.6,21.07l34.833,20.111v15.957 H612.34c-15.189-20.885-39.639-34.682-67.349-35.165c-23.848-0.417-45.626,9.108-61.376,24.737 c-26.417-13.027-57.538-16.255-83.05-17.921l-147.315-9.01c-18.387-1.125-5.965,30.828-22.414,18.791 c-13.847-10.339-30.925-16.596-49.456-16.92c-32.641-0.569-61.421,17.41-76.258,44.186H76.176v-72.144L86.8,185.109L86.8,185.109z"
    />
    {/*Three*/}
    <polygon 
        fill="rgb(190,190,190)" 
        points="92.127,396 642.933,396 642.933,298.921 227.025,275.4 60.568,275.4 60.552,329.4 92.127,396"
    />
    {/*Rocker*/}
    <path 
        fill="rgb(150,150,150)" 
        d="M642.933,379.3V396H92.127l-0.001-0.002L92.127,396l0,0l-4-16.7 C283.727,379.3,447.309,379.3,642.933,379.3L642.933,379.3z"
    />
    {/*Inset Highlight*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v41.717l280.313-0.024C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />
    {/*Inset Shadow*/}
    <path 
        fill="rgb(90,90,90)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v12.312l251.604,10.985c10.855,0.475,22.532,9.438,26.881,16.582c0.765,1.256,1.308,1.813,1.828,1.813 C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />  
    {/*Door Handle Highlight*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M302.899,232.38c-0.903-1.849-2.974-4.587-8.14-6.69 c-9.912-4.039-26.723-4.895-28.843-5.051c-2.937-0.219-9.122-0.149-8.186,5.914l0.478,3.094L302.899,232.38L302.899,232.38z"
    />
    {/*Door Handle Shadow*/}
    <path 
        fill="rgb(90,90,90)" 
        d="M266.162,231.082c1.954,0,3.548,1.594,3.548,3.548	s-1.594,3.548-3.548,3.548c-1.953,0-3.547-1.594-3.547-3.548S264.209,231.082,266.162,231.082L266.162,231.082z M300.152,232.212 l-29.457-1.802c0.471,5.016,2.687,6.109,4.926,6.132l20.105,1.186C300.893,237.779,300.152,232.212,300.152,232.212 L300.152,232.212z"
    />
    {/*One Highlight*/}
    <polygon 
        fill="rgb(255,255,255)" 
        points="436.5,209.563 86.8,185.109 76.176,203.256 77.452,203.257 436.5,209.563"
    />
    {/*Mirror Body Shadow*/}
    <path 
        fill="rgb(190,190,190)" 
        d="M420.018,215.521l1.227,1.87 c-8.865-0.307-14.482,2.165-16.687,3.683c-2.327,1.602-2.546,5.234,3.085,4.68l25.139-2.47c1.26,0.041,2.572-0.003,3.807-0.202 c1.378-0.223,4.542-1.097,3.238-3.086l-2.383-3.635c-1.073,0.17-2.324,0.216-3.747,0.117 C429.137,216.16,424.577,215.84,420.018,215.521L420.018,215.521z"
    />

{/*Red Stripes*/}

    {/*Two*/}
    <path 
        fill="rgb(180,0,0)" 
        d="M60.552,329.4L92.127,396h194.5L151.318,189.621L86.8,185.109 l-10.624,18.146l0.018,72.145H60.568L60.552,329.4L60.552,329.4z M546.023,396h109.756V275.4l-12.847-24.655L608.1,230.634 l-171.6-21.07l-13.32-0.932L546.023,396L546.023,396z"
    />
    {/*One*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M86.8,185.109l64.519,4.512l27.269,41.592	c-31.483,0.471-59.052,18.178-73.465,44.188H76.193l-0.018-72.145L86.8,185.109L86.8,185.109z M423.18,208.632l13.32,0.932 l171.6,21.07l34.833,20.111v15.957H612.34c-15.189-20.885-39.639-34.682-67.349-35.165c-23.848-0.417-45.626,9.108-61.376,24.737	c-11.795-5.816-24.527-9.679-37.278-12.321L423.18,208.632L423.18,208.632z"
    />
    {/*One Front Bumper*/}   
    <polygon 
        fill="rgb(210,0,0)" 
        points="655.779,275.399 642.933,250.744 608.099,230.634 642.933,285.278 642.933,298.921 655.779,298.921 655.779,275.399 	"
    />
    {/*Three*/}
    <path  
        fill="rgb(165,0,0)" 
        d="M92.127,396h194.5l-79.069-120.6H60.552v54L92.127,396L92.127,396 z M546.023,396h96.909v-97.079l-166.739-9.43L546.023,396L546.023,396z"
    />
    {/*Three Front Bumper*/}
    <polygon 
        fill="rgb(190,0,0)" 
        points="655.779,379.3 655.779,298.921 642.933,298.921 642.933,379.3 655.779,379.3 "
    />
    {/*Vent Background*/}
    <path 
        fill="rgb(220,0,0)" 
        d="M629.269,348.577l18.681,4.628l2.489-0.004 c1.779-0.004,3.422-0.325,3.422-2.821l-0.001-29.823c0-1.021-0.404-1.261-0.984-1.281l-21.414-0.759 c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603C625.877,344.809,626.697,347.94,629.269,348.577L629.269,348.577z"
    />
    {/*Vent*/}
    <path 
        fill="rgb(160,0,0)" 
        d="M648.527,353.204l-9.437-5.126c-1.72-0.934-2.519-2.618-2.52-4.77 l-0.005-11.837c0-2.773,0.814-4.013,2.066-4.716l13.386-7.511l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603 c0,2.714,0.82,5.846,3.392,6.482l18.681,4.628L648.527,353.204L648.527,353.204z"
    />
    {/*Vent Shadow*/}
    <path 
        fill="rgb(100,0,0)" 
        d="M628.042,324.644c-0.001-2.038,1.858-2.907,3.285-3.068 l20.691-2.33l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603c0,2.714,0.82,5.846,3.392,6.482 c-0.957-1.553-1.22-4.483-1.221-5.71L628.042,324.644L628.042,324.644z"
    />
    {/*Vent Highlight*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M632.043,348.424l12.192,3.385l-7.12-4.247 c-6.029-3.596-8.149-15.236-8.107-8.605C629.051,345.587,629.347,347.676,632.043,348.424L632.043,348.424z"
    />
    {/*Rear Bumper*/}
    <polygon 
        fill="rgb(155,0,0)" 
        points="76.176,329.4 92.126,396 179.855,396 179.855,329.4 76.176,329.4 	"
    />
    {/*Rear Bumper Highlight*/}
    <polygon 
        fill="rgb(255,0,0)" 
        points="76.176,285.279 60.552,285.279 60.568,275.4 76.176,275.4 76.176,285.279 	"
    />
    {/*Rear Bumper Shadow*/}
    <polygon 
        fill="rgb(140,0,0)" 
        points="60.552,329.4 76.176,329.4 92.127,396 60.552,329.4"
    />
    {/*Rocker*/}
    <path 
        fill="rgb(140,0,0)" 
        d="M642.933,379.3V396h-99.404v-16.7H642.933L642.933,379.3z M286.627,396h-194.5l-0.001-0.002l0,0.002h0l-4-16.7c171.683,0,80.209,0,187.55,0L286.627,396L286.627,396z"
    />
    {/*Rocker Front*/}
    <polygon 
        fill="rgb(175,0,0)" 
        points="642.933,379.3 642.933,396 655.779,396 655.779,379.3 642.933,379.3"
    />
    {/*Inset Highlight*/}
    <polygon 
        fill="rgb(255,0,0)" 
        points="237.141,320.521 179.855,318.02 179.855,359.736 262.846,359.729 237.141,320.521"
    />
    {/*Front Lip Highlight*/}
    <polygon 
        fill="rgb(255,0,0)" 
        points="543.528,365.473 655.779,365.473 655.779,364.026 642.933,362.38 633.41,364.026 543.528,364.026 543.528,365.473"
    />
    {/*One Highlight*/}
    <polygon 
        fill="rgb(255,0,0)" 
        points="151.318,189.621 86.8,185.109 76.176,203.256 77.452,203.257 161.223,204.729 151.318,189.621 	"
    />
    {/*Mirror Background*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M437.443,216.361c4.697-0.74,6.028-3.823,3.786-7.244l-3.907-5.96 c-0.822-1.253-3.626-4.647-5.669-6.215c-6.813-5.228-12.349-6.552-21.103-6.552c-4.264,0-5.566,0.952-7.2,4.458 c-0.749,1.604-1.124,3.95-1.124,5.72v5.09c0,1.447,0.091,3.408,1.29,4.729l2.525,2.78c0.802,0.882,2.007,1.519,3.195,1.601 l10.78,0.754L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror Base*/}
    <path 
        fill="rgb(120,0,0)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-13.679-0.957L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror_Base_Highlight*/}
    <path 
        fill="rgb(200,0,0)" 
        d="M438.299,219.592l-1.062-1.619 c-0.336-0.513-1.093-0.805-1.733-0.85l-14.267-0.997l0.845,1.288l7.073,0.523c2.369,0.174,3.686,0.219,5.114,2.258	c0.733,1.045,2.132,1.713,3.148,1.344C438.434,221.169,438.88,220.408,438.299,219.592L438.299,219.592z"
    />
    {/*"Mirror_Shadow"*/}
    <path 
        fill="rgb(140,0,0)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-24.459-1.711c-1.188-0.082-2.394-0.719-3.195-1.601l-2.525-2.78c-0.374-0.412-0.64-0.886-0.829-1.388	c6.532,0.457,33.813,2.364,38.542,0.118C443.472,212.538,442.141,215.621,437.443,216.361L437.443,216.361z"
    />
    {/*"Mirror_Highlight"*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M402.947,203.555c10.225,2.229,20.418-6.53,32.119-2.197 c-1.167-1.412-2.479-2.742-3.855-3.847c-3.146-2.373-6.389-4.21-10.196-5.287c-3.183-0.815-6.384-1.06-9.66-1.109	c-3.919-0.018-5.603,0.411-7.351,4.036c-0.744,1.691-1.035,3.584-1.057,5.423V203.555L402.947,203.555z"
    />
    
{/*"Livery"*/}


    {/*Wing Backgroung*/}
    
    {/*CF Lines*/}
    
    {/*"12 Back"*/}
    
    {/*"12"*/}
    
    {/*Marlboro Logo*/}
    <polygon 
        fill="rgb(205,0,0)" 
        points="422.586,257.972 403.547,266.666 404.524,248.025 441.589,249.968 440.611,268.608 422.586,257.972 	"
    />
    {/*"Marlboro"*/}
    <path 
        fill="rgb(0,0,0)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M402.272,292.307l0.689-13.151c0.085-1.631-0.043-2.737-0.386-3.317 c-0.342-0.58-1.001-0.896-1.977-0.947c-1.673-0.087-2.572,1.075-2.698,3.488l-0.716,13.661c-0.086,1.631,0.043,2.736,0.385,3.317 c0.343,0.58,0.979,0.895,1.907,0.943c0.976,0.051,1.664-0.203,2.066-0.761C401.945,294.981,402.188,293.903,402.272,292.307 L402.272,292.307z M411.678,286.155c-0.459,8.767-4.567,12.947-12.326,12.541c-3.809-0.199-6.643-1.464-8.5-3.794	c-1.857-2.329-2.674-5.651-2.447-9.967c0.225-4.282,1.382-7.484,3.473-9.607c2.092-2.122,5.041-3.083,8.851-2.884 C408.486,272.852,412.136,277.421,411.678,286.155L411.678,286.155z M377.287,288.288l0.51-9.736	c0.14-2.65-0.584-4.018-2.171-4.101c-0.793-0.041-1.345,0.219-1.655,0.782c-0.31,0.563-0.509,1.677-0.597,3.343l-0.518,9.889 c-0.118,2.243-0.065,3.702,0.156,4.379c0.223,0.676,0.753,1.036,1.593,1.08c0.934,0.049,1.585-0.326,1.954-1.125 C376.929,292.001,377.172,290.497,377.287,288.288L377.287,288.288z M386.532,284.633c-0.466,8.903-3.569,13.204-9.309,12.904	c-2.1-0.11-3.835-0.934-5.204-2.471l-0.509,1.659l-9.868-0.517l0.144-2.753l2.17,0.114l1.533-29.26l-2.17-0.113l0.147-2.804	l10.778,0.564l-0.545,10.399c1.056-0.49,1.903-0.813,2.542-0.966c0.641-0.154,1.334-0.212,2.08-0.173 c2.753,0.145,4.862,1.405,6.329,3.782C386.117,277.378,386.744,280.589,386.532,284.633L386.532,284.633z M360.051,296.125 l-13.178-0.69l0.144-2.752l2.208,0.115l1.533-29.259l-2.635-0.139l0.146-2.804l11.397,0.598l-1.68,32.063l2.208,0.116 L360.051,296.125L360.051,296.125z M348.785,274.169c-0.069,1.325-0.526,2.358-1.371,3.098s-1.952,1.073-3.322,1.001	c-1.182-0.062-2.125-0.393-2.828-0.991s-1.029-1.392-0.978-2.377c0.046-0.884,0.427-1.801,1.14-2.752 c-1.223,0.72-2.03,1.437-2.423,2.147c-0.394,0.713-0.63,1.833-0.71,3.362l-0.762,14.528l2.482,0.13l-0.145,2.752l-13.4-0.702 l0.145-2.752l2.197,0.115l1.031-19.677l-2.197-0.115l0.145-2.752l10.635,0.557l0.203,1.544c1.716-1.307,3.466-1.914,5.25-1.82 c1.549,0.081,2.768,0.554,3.67,1.419C348.438,271.749,348.854,272.844,348.785,274.169L348.785,274.169z M325.462,292.729 c-1.95,1.295-4.061,1.883-6.333,1.764c-1.234-0.064-2.215-0.253-2.941-0.563s-1.611-0.919-2.653-1.826 c-0.881,0.738-1.737,1.238-2.567,1.502c-0.831,0.263-1.938,0.358-3.321,0.285c-2.667-0.14-4.745-0.904-6.231-2.294 c-1.487-1.39-2.172-3.224-2.053-5.5c0.258-4.928,3.647-7.221,10.168-6.879l3.556,0.187l0.302-5.761 c0.063-1.189-0.141-2.034-0.609-2.536s-1.321-0.785-2.557-0.85c-0.84-0.044-1.616,0.137-2.331,0.543 c0.862,0.556,1.455,1.063,1.777,1.523c0.323,0.46,0.47,0.962,0.441,1.506c-0.048,0.917-0.534,1.676-1.456,2.274 c-0.924,0.6-2.027,0.865-3.311,0.798c-1.334-0.069-2.463-0.495-3.389-1.276c-0.925-0.781-1.359-1.698-1.305-2.752	c0.092-1.732,1.189-3.064,3.293-3.993s4.86-1.305,8.269-1.126c6.915,0.363,10.231,3.229,9.95,8.598l-0.716,13.661 c-0.034,0.646,0.221,0.983,0.764,1.012c0.544,0.028,1.204-0.295,1.983-0.97L325.462,292.729L325.462,292.729z M312.66,287.508	l0.291-5.557l-0.814-0.042c-1.531-0.08-2.56,0.164-3.084,0.732c-0.525,0.569-0.839,1.822-0.94,3.759 c-0.143,2.719,0.626,4.122,2.306,4.21C311.801,290.684,312.548,289.648,312.66,287.508L312.66,287.508z M299.311,292.942 l-14.715-0.771l0.157-3.007l2.428,0.127l1.144-21.817l-7.04,24.523l-6.474-0.339l-4.047-25.564l-1.167,22.275l2.575,0.135	l-0.158,3.008l-9.417-0.494l0.157-3.007l2.502,0.131l1.507-28.749l-2.502-0.132l0.161-3.058l15.021,0.787l2.514,16.999 l4.463-16.634l14.715,0.771l-0.16,3.059l-2.428-0.128l-1.507,28.75l2.429,0.127L299.311,292.942L299.311,292.942z M434.03,278.637 c-0.069,1.325-0.526,2.357-1.371,3.098c-0.845,0.739-1.952,1.073-3.322,1.001c-1.182-0.062-2.124-0.393-2.827-0.991 c-0.704-0.6-1.029-1.392-0.979-2.377c0.047-0.884,0.427-1.801,1.141-2.752c-1.224,0.72-2.031,1.436-2.424,2.147 s-0.629,1.833-0.709,3.362l-0.762,14.527l2.481,0.13l-0.144,2.753l-13.401-0.702l0.145-2.753l2.198,0.115l1.031-19.676	l-2.198-0.115l0.145-2.753l10.635,0.558l0.204,1.544c1.715-1.308,3.465-1.914,5.25-1.82c1.548,0.081,2.767,0.554,3.669,1.419 C433.684,276.216,434.1,277.312,434.03,278.637L434.03,278.637z M447.502,294.677l0.689-13.151 c0.085-1.631-0.043-2.736-0.386-3.316c-0.342-0.581-1.001-0.896-1.977-0.947c-1.673-0.088-2.572,1.074-2.698,3.487l-0.716,13.661 c-0.086,1.632,0.043,2.737,0.385,3.317c0.343,0.58,0.979,0.895,1.907,0.943c0.976,0.051,1.664-0.202,2.066-0.761 S447.418,296.274,447.502,294.677L447.502,294.677z M456.908,288.525c-0.46,8.768-4.568,12.947-12.326,12.541 c-3.81-0.199-6.644-1.464-8.501-3.793c-1.858-2.33-2.673-5.652-2.447-9.968c0.225-4.282,1.382-7.484,3.474-9.606
		c2.09-2.123,5.041-3.084,8.85-2.885C453.715,275.222,457.365,279.791,456.908,288.525L456.908,288.525z"
    />
	{/*Shell Logo Back"*/}
    <path 
        fill="rgb(175,0,0)" 
        d="M269.753,341.924c2.911-3.109,8.31-3.452,11.692,0.247
		c1.5,1.871,2.25,4.095,1.908,6.835l-2.566,1.913l-0.324,2.989l-4.06,0.027c-0.579,0.56-1.237,0.544-1.745,0.014l-4.114-0.01
		l-0.337-3.01l-2.589-1.846C267.149,346.105,268.101,343.833,269.753,341.924L269.753,341.924z"
    />
    {/*Shell Logo Center"*/}
    <path 
        fill="rgb(255,245,0)" 
        d="M281.989,348.389l-2.489,1.826l-0.239,2.347l-3.038,0.022 c-0.467,0.602-0.998,0.556-1.408,0.012l-3.07-0.009l-0.262-2.274l-2.537-1.936c-0.188-0.703-0.114-1.402,0.162-2.154l4.053,4.126	l0.127-0.096l-3.957-4.852c0.01-0.595,0.384-1.171,0.924-1.737l3.578,6.122l0.15-0.08l-3.215-6.712	c0.434-0.668,1.002-1.02,1.633-1.227l2.201,7.711l0.159-0.053l-1.606-8.026c0.289-0.22,0.64-0.377,1.079-0.444 c0.216-0.026,0.475-0.023,0.815-0.012l0.369,8.514l0.141,0.009l0.293-8.487c0.252-0.014,0.502-0.018,0.754,0.006	c0.441,0.04,0.874,0.169,1.145,0.404l-1.514,8.037l0.136,0.02l2.178-7.699c0.888,0.406,1.415,0.848,1.59,1.229l-3.131,6.72 l0.136,0.128l3.521-6.2c0.485,0.478,0.874,1.002,0.995,1.655l-3.848,4.851l0.081,0.081l3.915-3.964 C282.07,346.822,282.189,347.498,281.989,348.389L281.989,348.389z"
    />
    {/*Shell Text*/}
    <path 
        fill="rgb(0,0,0)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M325.373,343.324h3.004c0.082,0,0.148,0.065,0.148,0.147v8.261	c0,0.081-0.066,0.147-0.148,0.147h-3.004c-0.082,0-0.148-0.066-0.148-0.147v-8.261C325.225,343.39,325.291,343.324,325.373,343.324 L325.373,343.324z M320.352,343.324h3.004c0.082,0,0.148,0.065,0.148,0.147v8.261c0,0.081-0.066,0.147-0.148,0.147h-3.004 c-0.082,0-0.148-0.066-0.148-0.147v-8.261C320.203,343.39,320.27,343.324,320.352,343.324L320.352,343.324z M311.681,345.675 c1.688-0.071,3.386-0.066,5.062,0.112c1.031,0.143,1.809,0.607,1.961,1.697l0.041,1.553c0.002,0.197-0.082,0.285-0.236,0.299 l-5.986-0.038c-0.1,0.006-0.157,0.065-0.171,0.149c-0.103,0.774,0.135,1.253,0.868,1.298l1.406-0.015 c0.23-0.011,0.679-0.344,0.719-0.67c0.01-0.179,0.091-0.26,0.268-0.267l2.692-0.002c0.261-0.002,0.374,0.097,0.36,0.321 c-0.084,0.944-0.619,1.592-1.816,1.807c-1.383,0.058-3.318,0.032-5.006,0.035c-1.783-0.037-2.47-0.463-2.771-1.357 c-0.253-1.081-0.246-2.275-0.039-3.296C309.273,346.358,309.942,345.76,311.681,345.675L311.681,345.675z M313.286,346.971 c0.438-0.045,0.876-0.037,1.313,0.018c0.426,0.079,1.107,0.776,0.606,1.034c-0.87,0.027-1.732,0.025-2.591,0.009	C312.244,347.701,312.602,347.088,313.286,346.971L313.286,346.971z M298.34,343.324h3.004c0.082,0,0.148,0.065,0.148,0.147v2.526 c0.063,0.06,0.163,0.086,0.287,0.068c0.309-0.09,0.609-0.228,0.913-0.263c2.77-0.239,4.689,0.078,4.874,1.529l-0.035,2.064v2.335 c0,0.081-0.067,0.147-0.148,0.147h-2.885c-0.082,0-0.148-0.066-0.148-0.147v-2.357v-0.166l0,0v-1.179 c-0.107-0.843-2.389-0.795-2.857-0.103v3.805c0,0.081-0.066,0.147-0.148,0.147h-3.004c-0.082,0-0.148-0.066-0.148-0.147v-8.261 C298.191,343.39,298.258,343.324,298.34,343.324L298.34,343.324z M287.989,351.812c-2.195,0.005-2.61-1.138-2.62-2.6 c-0.001-0.081,0.078-0.147,0.174-0.147h3.524c0.096,0,0.177,0.066,0.174,0.147c-0.017,0.533,0.083,1.003,0.727,1.133l2.161,0.012 c0.613-0.07,0.888-0.573,0.818-1.327c-0.044-0.407-0.236-0.706-0.865-0.813l-3.988-0.093c-1.5-0.074-2.314-0.553-2.443-1.484 l0.006-1.645c0.074-1.037,0.777-1.722,2.631-1.778l4.838-0.051c1.965-0.082,2.981,0.31,3.35,1.026 c0.114,0.457,0.108,0.925,0.129,1.424c-0.018,0.178-0.132,0.261-0.34,0.249l-3.164-0.005c-0.153-0.008-0.229-0.086-0.225-0.234 c0.128-0.98-0.504-1.171-1.787-1.144c-1.291,0.004-1.855,0.176-1.94,0.595c-0.126,0.901,0.132,1.438,0.948,1.439l3.07,0.055 c2.563,0.043,3.474,0.776,3.52,1.974c0.26,2.129-0.402,2.947-1.514,3.189C292.825,351.906,290.45,351.994,287.989,351.812	L287.989,351.812z"
    />

    {/*"Hashmarks"*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M285.973,359.736H299.9V379.3h-13.928V359.736L285.973,359.736z M305.391,359.736 h12.587V379.3h-12.587V359.736L305.391,359.736z M323.468,359.736h10.445V379.3h-10.445V359.736L323.468,359.736z M340.073,359.736 h10.444V379.3h-10.444V359.736L340.073,359.736z M357.08,359.736h9.373V379.3h-9.373V359.736L357.08,359.736z M373.015,359.736	h8.035V379.3h-8.035V359.736L373.015,359.736z M387.075,359.736h7.499V379.3h-7.499V359.736L387.075,359.736z M400.601,359.736 h6.16V379.3h-6.16V359.736L400.601,359.736z M414.394,359.736h4.018V379.3h-4.018V359.736L414.394,359.736z M426.044,359.736h3.481 V379.3h-3.481V359.736L426.044,359.736z M437.024,359.736h2.946V379.3h-2.946V359.736L437.024,359.736z M445.06,359.736h2.41V379.3 h-2.41V359.736L445.06,359.736z"
    />


    {/*H Back*/}
    <polygon 
        fill="rgb(0,0,0)" 
        points="77.516,308.105 82.375,308.105 82.375,308.387 80.229,308.387 80.229,313.629 92.332,313.629 92.332,308.387 90.186,308.387 90.186,302.814 92.332,302.814 92.332,297.572 80.229,297.572 80.229,302.814 82.375,302.814 82.375,303.094 77.516,303.094 77.516,302.814 79.66,302.814 79.66,297.572 67.557,297.572 67.557,302.814 69.703,302.814 69.703,308.387 67.557,308.387 67.557,313.629 79.66,313.629 79.66,308.387 77.516,308.387 77.516,308.105 	"
    /> 
    {/*H Red Back*/}
    <polygon 
        fill="rgb(200,0,0)" 
        points="76.563,307.152 83.328,307.152 83.328,309.34 81.182,309.34 81.182,312.676 91.379,312.676 91.379,309.34 89.232,309.34 89.232,301.861 91.379,301.861 91.379,298.525 81.182,298.525 81.182,301.861 83.328,301.861 83.328,304.047 76.563,304.047 76.563,301.861 78.707,301.861 78.707,298.525 68.51,298.525 68.51,301.861 70.656,301.861 70.656,309.34 68.51,309.34 68.51,312.676 78.707,312.676 78.707,309.34 76.563,309.34 76.563,307.152 	"
    />
    {/*"H_Highlight"*/}
    <path 
        fill="rgb(255,0,0)" 
        d="M83.1,304.963h-7.453v-2.492l0.457-0.686v2.721h7.301 L83.1,304.963L83.1,304.963z M81.639,309.797l0.459,0.457h0.621l0.305-0.457H81.639L81.639,309.797z M68.969,309.797l0.457,0.457	h0.621l0.305-0.457H68.969L68.969,309.797z M69.426,299.439h8.367v1.508l0.457,0.457v-2.422h-9.281L69.426,299.439L69.426,299.439z M78.25,312.219l-0.457-0.459v-1.506h-2.146v-2.49l0.457-0.688v2.721h2.146V312.219L78.25,312.219z M90.922,312.19l-0.457-0.459 v-1.506h-2.146v-7.783l0.457-0.686v8.012h2.146V312.219L90.922,312.219z M90.465,300.947v-1.508h-8.367l-0.459-0.457h9.283v2.422 L90.465,300.947L90.465,300.947z"
    /> 




    

		</svg>
		</div>

	);//return
}